// @flow
import React from 'react';
import isEmpty from 'lodash/isEmpty';

import GroupChatMemberClient from '../../models/group_chats/GroupChatMemberClient';
import MemberItem from './MemberItem';
import type { Member } from '../../models/group_chats/Member';

type Props = {
  numberOfSeenMember: number,
  groupChatSize: number,
  id: number,
  groupChatId: number,
};

type State = {
  seenNumber: number,
  seenMembers: Array<Member>,
  unseenMembers: Array<Member>,
  isActive: boolean,
};

export default class GroupChatSeen extends React.Component<Props, State> {
  groupChatMemberClient = new GroupChatMemberClient();

  constructor(props: Props) {
    super(props);

    this.state = {
      seenNumber: 0,
      seenMembers: [],
      unseenMembers: [],
      isActive: true,
    };
  }

  async onClickButtonOpenModal() {
    const response = await this.groupChatMemberClient.fetchMembers(
      this.props.id,
    );
    this.setState({
      seenMembers: response.data.seen_members,
      unseenMembers: response.data.unseen_members,
    });
  }

  onClickSeenButton = () => {
    this.setState({ isActive: true });
  };

  onClickUnseenButton = () => {
    this.setState({ isActive: false });
  };

  render() {
    const { numberOfSeenMember } = this.props;
    const { seenMembers, unseenMembers, isActive } = this.state;

    return (
      <div className="chat-message__member-seen">
        <button
          type="button"
          data-toggle="modal"
          data-target={`#seenModal${this.props.id}`}
          className="btn-show-member chat-message__member-seen--btn-blue"
          onClick={() => this.onClickButtonOpenModal()}
        >
          <div>
            <strong className="number-of-seen-member">
              <i className="fas fa-angle-left" />
              <p className="chat-message__member-seen--number">
                {' '}
                既読{' '}
                {isEmpty(seenMembers) ? numberOfSeenMember : seenMembers.length}
              </p>
            </strong>
          </div>
        </button>
        <div
          className="modal fade modal-group-chat"
          id={`seenModal${this.props.id}`}
          role="dialog"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header modal-group-chat__member">
                <i className="fas fa-male float-left" />
                <button type="button" className="close" data-dismiss="modal">
                  &times;
                </button>
                <h2 className="modal-title">
                  <strong>既読メンバー</strong>
                </h2>
              </div>
              <div className="modal-body">
                <div role="tabpanel">
                  <ul className="nav nav-tabs group-chat-seen" role="tablist">
                    <li
                      role="presentation"
                      className="active group-chat-seen__tab"
                    >
                      <a
                        href="#readTab"
                        aria-controls="readTab"
                        role="tab"
                        data-toggle="tab"
                        onClick={this.onClickSeenButton}
                      >
                        既読 ({seenMembers.length})
                      </a>
                    </li>
                    <li role="presentation" className="group-chat-seen__tab">
                      <a
                        href="#unreadTab"
                        aria-controls="unreadTab"
                        role="tab"
                        data-toggle="tab"
                        onClick={this.onClickUnseenButton}
                      >
                        未読 ({unseenMembers.length})
                      </a>
                    </li>
                  </ul>
                  <div className="tab-content">
                    <div
                      role="tabpanel"
                      className={`tab-pane ${
                        isActive ? 'active' : ''
                      } seen-members`}
                      id="readTab"
                    >
                      <div className="row">
                        {seenMembers.map((member, index) => (
                          <MemberItem member={member} key={index} />
                        ))}
                      </div>
                    </div>
                    <div
                      role="tabpanel"
                      className={`tab-pane ${
                        !isActive ? 'active' : ''
                      } seen-members`}
                      id="unreadTab"
                    >
                      <div className="row">
                        {unseenMembers.map((member, index) => (
                          <MemberItem member={member} key={index} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
